import { useToast } from 'components/useToast';
import { MoneyFromCents } from '@libs/services/money';
import { Invoice, trpc } from 'src/trpc';
import { InvoiceItem } from '@libs/schemas/src/invoice';
import { Skeleton } from '@/components/ui/skeleton';
import { InvoiceSelectItemsSheet } from './InvoiceSelectItemsSheet';

export const InvoiceItemsSection = ({
  invoice,
  isLoading,
  refetchInvoice,
}: {
  invoice: Invoice;
  isLoading?: boolean;
  refetchInvoice: () => void;
}) => {
  const { successToast, errorToast, infoToast } = useToast();

  const { mutate: updateInvoiceItems, isPending: isUpdating } =
    trpc.admin.invoice.adminUpdateInvoiceItems.useMutation({
      onSuccess: async (data) => {
        successToast({
          title: 'Invoice Updated',
          description: 'Invoice has been updated successfully.',
        });
        if (data.createdProducts && data.createdProducts.length > 0) {
          data.createdProducts.map((p) => {
            infoToast({
              title: `Product "${p.label}" Created`,
              description: `The product was automatically created.`,
            });
          });
        }
        refetchInvoice();
      },
      onError: () => {
        errorToast({
          title: 'Update Failed',
          description: 'Failed to update invoice. Please try again.',
        });
      },
    });

  const handleSelectItems = (items: InvoiceItem[]) => {
    updateInvoiceItems({ invoiceId: invoice._id, items });
  };

  if (!invoice) return null;
  return (
    <>
      <div className="card flex flex-col gap-4 justify-start w-full p-4 mt-2 relative">
        <div className="flex flex-row justify-between w-full mb-4">
          <InvoiceSelectItemsSheet
            invoice={invoice}
            onSelectItems={handleSelectItems}
            isLoading={isLoading}
          />
        </div>

        <div className="flex flex-row justify-between  w-full">
          <p className="label text-xs">Invoice Items</p>
          <p className="label text-xs">Price</p>
        </div>
        {isUpdating || isLoading ? (
          <div className="flex flex-row justify-between w-full">
            <Skeleton className="w-full h-4" />
            <Skeleton className="w-full h-4" />
          </div>
        ) : (
          invoice.items.map((item: InvoiceItem, index: number) => (
            <div
              className="flex flex-row justify-between w-full"
              key={`${item.productId}-${index}`}
            >
              <div>
                <p className="text-text-primary text-sm">{item.label}</p>
                <p className="label text-xs">
                  {item.quantity} x {MoneyFromCents(item.unitPriceInCents || 0).toFormat()}
                </p>
                <p className="label text-xs">{item.description}</p>
                <p className="label text-xs">
                  {item.collectTaxes ? 'Taxable: Yes' : 'Taxable: No'}
                </p>
              </div>
              <div className="flex flex-col items-end">
                <p className="text-text-primary text-sm">
                  {MoneyFromCents(item.totalPriceInCents).toFormat()}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};
